import styled from 'styled-components'

import { COLOR } from 'styles/constants'

interface IViewOnGoogleMaps {
  destination?: google.maps.LatLngLiteral
  linkText?: string
}

const StyledLink = styled.a`
  display: flex;
  align-items: center;
  color: ${COLOR.BLUE_LV5};
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  text-decoration: none;
  :hover {
    color: ${COLOR.BLUE_LV4};
  }
  i {
    font-size: 20px;
    margin-right: 7px;
  }
  @media (max-width: 991px) {
    font-weight: 700;
    font-size: 14px;
    line-height: 1em;
  }
`
const Wrapper = styled.p`
  margin: 10px auto;
`
const GOOGLE_MAPS_QUERY_URL = 'https://www.google.com/maps/search/?api=1&query='
export const generateGoogleMapUrl = (destination?: google.maps.LatLngLiteral) =>
  `${GOOGLE_MAPS_QUERY_URL}${destination?.lat},${destination?.lng}`

export const ViewOnGoogleMaps: React.FC<IViewOnGoogleMaps> = ({
  destination,
  linkText,
}: IViewOnGoogleMaps) => {
  const googleMapUrl = destination ? generateGoogleMapUrl(destination) : GOOGLE_MAPS_QUERY_URL
  return (
    <Wrapper>
      <StyledLink href={googleMapUrl} target="_blank">
        <i className="fas fa-directions" />
        {linkText}
      </StyledLink>
    </Wrapper>
  )
}

ViewOnGoogleMaps.defaultProps = {
  destination: undefined,
  linkText: 'View on Google Maps',
}
